import { render, staticRenderFns } from "./CapituloSeisPage.vue?vue&type=template&id=32864c39"
import script from "./CapituloSeisPage.js?v=2?vue&type=script&lang=js&external"
export * from "./CapituloSeisPage.js?v=2?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports